import { ReactNode } from 'react';
import styles from './DocumentViewerBase.module.css';

interface DocumentViewerBaseProps {
	isEmpty?: boolean;
	emptyMessage?: string;
	children?: ReactNode;
	scrollContainerRef?: React.RefObject<HTMLDivElement | null>;
	isModal?: boolean;
}

export const DocumentViewerBase = ({
	isEmpty = false,
	emptyMessage = 'Selecione uma política para visualizar',
	children,
	scrollContainerRef,
	isModal = false,
}: DocumentViewerBaseProps) => {
	if (isEmpty) {
		return (
			<div className={styles.emptyState}>
				<p className={styles.emptyText}>{emptyMessage}</p>
			</div>
		);
	}

	const viewerClassName = isModal ? `${styles.viewer} ${styles.viewerModal}` : styles.viewer;

	const documentClassName = isModal
		? `${styles.document} ${styles.documentModal}`
		: styles.document;

	return (
		<div className={viewerClassName} ref={scrollContainerRef}>
			<div className={documentClassName}>{children}</div>
		</div>
	);
};
